import { render, staticRenderFns } from "./MarketplaceHeader.vue?vue&type=template&id=647fe609&scoped=true&"
import script from "./MarketplaceHeader.vue?vue&type=script&lang=js&"
export * from "./MarketplaceHeader.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceHeader.vue?vue&type=style&index=0&id=647fe609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647fe609",
  null
  
)

export default component.exports